import { Children, isValidElement, ReactNode } from "react";

import { CounterValue } from "features/ui/Icons/CounterIcon";

export const splitSummary = (children: ReactNode) => {
  const childArray = Children.toArray(children);
  const summary = childArray.find(
    (child) => isValidElement(child) && child.type === "summary"
  );
  const summaryChildren = isValidElement<{ children?: ReactNode }>(summary)
    ? summary.props.children
    : undefined;

  return {
    hasSummary: summary !== undefined,
    summaryChildren,
    content: childArray.filter((child) => child !== summary),
  };
};

// Full-width digits and periods too: Japanese answers produce them.
const ORDINAL_PATTERN = /^\s*([1-3１-３])[.．]\s+/;
const RANK_BY_DIGIT: Record<string, CounterValue> = {
  "1": 1,
  "2": 2,
  "3": 3,
  "１": 1,
  "２": 2,
  "３": 3,
};

export const splitOrdinal = (
  summaryChildren: ReactNode
): { ordinal?: CounterValue; title: ReactNode } => {
  const [first, ...rest] = Children.toArray(summaryChildren);
  const match = typeof first === "string" && ORDINAL_PATTERN.exec(first);

  const remainder =
    typeof first === "string" ? first.slice(match ? match[0].length : 0) : "";
  const ordinal = match ? RANK_BY_DIGIT[match[1]] : undefined;

  if (
    typeof first !== "string" ||
    ordinal === undefined ||
    (!remainder && rest.length === 0)
  ) {
    return { title: summaryChildren };
  }

  return { ordinal, title: [remainder, ...rest] };
};
